import { DataTable } from '@repo/ui';
import { ProfessionalsWorkJourneyOrganization } from 'domain/models';
import { useMemo } from 'react';
import { TableColumn } from 'react-data-table-component';

import {
  buildOrganizationRows,
  getInitials,
  WorkJourneyTableRow,
} from '../helpers';
import { WorkJourneyTimeLog } from '../work-journey-time-log';

const workJourneyColumns: TableColumn<WorkJourneyTableRow>[] = [
  {
    name: <span className="font-weight-bold fs-13">DATA</span>,
    selector: (row) => row.date,
    sortable: true,
    cell: (row) => (
      <div className="d-flex flex-column">
        <strong>{row.formattedDate}</strong>
        <span className="text-muted">{row.weekDay}</span>
      </div>
    ),
    minWidth: '120px',
  },
  {
    name: <span className="font-weight-bold fs-13">PROFISSIONAL</span>,
    selector: (row) => row.professionalName,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center gap-3">
        {row.professionalPhoto ? (
          <img
            className="rounded-circle object-fit-cover flex-shrink-0"
            src={row.professionalPhoto}
            alt={row.professionalName}
            width={40}
            height={40}
          />
        ) : (
          <div className="avatar-sm flex-shrink-0">
            <span className="avatar-title rounded-circle bg-primary text-white fs-14">
              {getInitials(row.professionalName)}
            </span>
          </div>
        )}

        <div className="d-flex flex-column">
          <strong className="text-truncate">{row.professionalName}</strong>
          <span className="text-muted">{row.role}</span>
        </div>
      </div>
    ),
    minWidth: '300px',
  },
  {
    name: <span className="font-weight-bold fs-13">1º ENTRADA</span>,
    cell: (row) => <WorkJourneyTimeLog timeLog={row.workLogs?.firstEntry} />,
    minWidth: '150px',
  },
  {
    name: <span className="font-weight-bold fs-13">1º SAÍDA</span>,
    cell: (row) => <WorkJourneyTimeLog timeLog={row.workLogs?.firstExit} />,
    minWidth: '150px',
  },
  {
    name: <span className="font-weight-bold fs-13">2º ENTRADA</span>,
    cell: (row) => <WorkJourneyTimeLog timeLog={row.workLogs?.secondEntry} />,
    minWidth: '150px',
  },
  {
    name: <span className="font-weight-bold fs-13">2º SAÍDA</span>,
    cell: (row) => <WorkJourneyTimeLog timeLog={row.workLogs?.secondExit} />,
    minWidth: '150px',
  },
  {
    name: <span className="font-weight-bold fs-13">LOCAL (ENDEREÇO)</span>,
    selector: (row) => row.locationName,
    sortable: true,
    cell: (row) => (
      <div className="d-flex flex-column py-1">
        <strong>{row.locationName}</strong>
        <span className="text-muted">{row.locationAddress}</span>
      </div>
    ),
    minWidth: '360px',
  },
];

interface IProps {
  organization: ProfessionalsWorkJourneyOrganization;
}

/**
 * Tabela de jornada da organizacao. Ordenacao e paginacao sao locais: a API
 * devolve todos os registros de uma vez. A busca fica so no topo da lista,
 * fora da tabela.
 */
export const OrganizationJourneyTable = ({ organization }: IProps) => {
  const rows = useMemo(
    () => buildOrganizationRows(organization),
    [organization],
  );

  return (
    <DataTable
      pagination
      data={rows}
      actions={[]}
      loading={false}
      canSearch={false}
      noDataVariant="filter"
      columns={workJourneyColumns}
      noDataTitle="Nenhum registro encontrado"
      noDataDescription="Não há jornada de trabalho para esta organização."
    />
  );
};
